/**
 * dashboardLayout.js — the class names of Dashboard's 3D viewport. Pure, for the node tests.
 *
 * Agent mode drops the legacy layout classes: `.fullscreen` / `.with-chat` (Dashboard.css) set
 * left/right/width with the same specificity as `.is-agent` (AgentLayout.css) and Dashboard.css is
 * imported later, so keeping one of them pinned the stage to the whole window instead of the centre
 * column between the case rail and the agent stream (CONTRACT 10.5 layout).
 */
export function viewportClassName({ agentMode = false, chatOpen = false } = {}) {
  if (agentMode) return 'vehicle-viewport-dynamic is-agent';
  return `vehicle-viewport-dynamic ${chatOpen ? 'with-chat' : 'fullscreen'}`;
}
